@if (playerInfo) {
	<div class="sst_PlayerClinicalVignetteContainer nomargin">
		<div class="header" [style.font-size]="getFontSizeHeader + 'em'">
			{{ getClinicalVignetteTextHeader() }}
		</div>
		<div class="clinicalText" [style.font-size]="getFontSize + 'em'" [innerHtml]="getClinicalVignetteText"></div>
	</div>
}
